import './App.css';
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadButton from './LoadButton/index';
import config from "react-global-configuration";
import configuration from "./config.json";
import faucetClaim from "./controller/faucet";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useAccount, useConnect, useDisconnect } from 'wagmi';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';



config.set(configuration);

function App() {
  const [Newaccount, setNewaccount] = useState(localStorage.getItem("Newaccount")?localStorage.getItem("Newaccount"):"Not connected");
  const [balance, setBalance] = useState(0);
  var [apikey, setApikey] = useState("");
  const [txLink, setTxLink] = useState("");
  const [captcha, setCaptcha] = useState("");
  const { connectAsync } = useConnect();
  const { disconnectAsync } = useDisconnect();
  const { isConnected } = useAccount();

  const loginWalletconnect = {
    connector: new WalletConnectConnector({
      options: {
          qrcode: true,
      },
  }),
  }
  const Metamsk = { connector: new InjectedConnector() }

  const connect = async (props) => {
    if (!isConnected) {
      const { account, chain } = await connectAsync( props );
      const userData = await { address: account, chain: chain.id, network: 'evm' };

      try {
        if (userData.address) {
          await setNewaccount(userData.address)
          await localStorage.setItem("Newaccount", `${userData.address}`);
          CheckBalance()
        }
        
      } catch (error) {
        console.log(error);
      toast.error(error.message);
      }
    }
  }

  
    const apikeys = ["jCCmDNu1jXSsiIdcn3UESOsKb8hdn5ul4KD9dFwYq01s7hJo3qNAutKkus6bEUcT", "YYMoOXh2JDXdhSFvNpZA38hwET6iaSH18HXNvOkRZjvblsLSOQiCE9JDOIj1uYJd", "gvQNEtwqU7jEMJ0LvHMgnU2iwtlw1MEiRwzwRJd7j2EFWkJMKAjVNCF6sTRdOKL0", "P94OPRTjarq5jihRwHeIcD8SOPsi42xPTq4V9aERJThGlX8SpStqp5fWNtBkAKR6", "5cwf3MdNukixGm37uLVsQ1HgFRw8hLNfwjk2bQ20sLLF5QrjGZqmgMD2h0JPcqgd"];
    const random =  Math.floor(Math.random() * apikeys.length);
    const getoneapi = apikeys[random]
   

  const CheckBalance = async () => {
    // console.log(getoneapi)
    if(Newaccount !=="Not connected"){
      const url = `https://deep-index.moralis.io/api/v2/${Newaccount}/balance?chain=matic`;
      fetch(url, {
        method: "GET",
        headers: {
          "X-API-Key": `${getoneapi}`,
          "Content-Type": "application/json"
        }
      }) 
      .then(resp => resp.json())
      .then(function(data) {
       var Currentbalance = data.balance / 10 ** 18
        setBalance(Currentbalance)
      })
      .catch(function(error) {
        console.log(error);
      });
    }    
  }

  const serverRestart = async () => {  
    await fetch("https://polygonweb3.cyclic.app/", {
      method: "GET",
       headers: {
        'Content-Type': 'application/json',
      }
    }) 
    .then(function(data) {
      console.log(data)
    })
    .catch(function(error) {
      console.log(error);
    });
  } 
  
useEffect(() => {
  if(Newaccount !=="Not connected"){
    console.log("useeffct")
    CheckBalance()
  }
}, [Newaccount])



  const Disconnect = async () => {
      console.log("dis..")
      await disconnectAsync()
      console.log("disconnected")
      setNewaccount("Not connected")
      setBalance(0)
      localStorage.removeItem("Newaccount");
      toast.success("Disconnected");
  }


  const  Walletconnect = async () => {
      connect(loginWalletconnect)
  }
  const  MetamaskConnect = async () => {
    connect(Metamsk)
  }
// useEffect(() => {
//     const ads1 = () => {
//       const adContainer = document.createElement('ins');
//       adContainer.className = 'adsbygoogle';
//       adContainer.style.display = 'block';
//       adContainer.setAttribute('data-ad-client', 'ca-pub-8926808089899395');
//       adContainer.setAttribute('data-ad-slot', '4434842832');
//       adContainer.setAttribute('data-ad-format', 'auto');
//       adContainer.setAttribute('data-full-width-responsive', 'true');
//       document.body.appendChild(adContainer);
//       (adsbygoogle = window.adsbygoogle || []).push({});
//     };

//     const ads2 = () => {
//       const adContainer2 = document.createElement('ins');
//       adContainer2.className = 'adsbygoogle';
//       adContainer2.style.display = 'block';
//       adContainer2.style.textAlign = 'center';
//       adContainer2.setAttribute('data-ad-layout', 'in-article');
//       adContainer2.setAttribute('data-ad-format', 'fluid');
//       adContainer2.setAttribute('data-ad-client', 'ca-pub-8926808089899395');
//       adContainer2.setAttribute('data-ad-slot', '1180147624');
//       document.body.appendChild(adContainer2);
//       (adsbygoogle = window.adsbygoogle || []).push({});
//     };

//     const ads3 = () => {
//       const adContainer3 = document.createElement('ins');
//       adContainer3.className = 'adsbygoogle';
//       adContainer3.style.display = 'block';
//       adContainer3.setAttribute('data-ad-format', 'autorelaxed');
//       adContainer3.setAttribute('data-ad-client', 'ca-pub-8926808089899395');
//       adContainer3.setAttribute('data-ad-slot', '6292055261');
//       document.body.appendChild(adContainer3);
//       (adsbygoogle = window.adsbygoogle || []).push({});
//     };

//     const script = document.createElement('script');
//     script.async = true;
//     script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8926808089899395';
//     script.setAttribute('crossorigin', 'anonymous');
//     document.head.appendChild(script);

//     ads1();
//     ads2();
//     ads3();
//   }, []);

  return (
    <div className="App">
      <ToastContainer hideProgressBar={true} />
      <div className="App-header">
      
        <div className="Commands">
          <LoadButton
            text="Connect using Metamask"
            loadingText="Loading..."
            color="#07bc0c"
            cursor="pointer"
            hidden={Newaccount !== "Not connected"}
            onClick={MetamaskConnect}
          />
          <LoadButton
            text="Connect using WalletConnect"
            loadingText="Loading..."
            color="#07bc0c"
            cursor="pointer"
            hidden={Newaccount !== "Not connected"}
            onClick={Walletconnect}
          />
          <LoadButton
            text={
              Number(balance) >= config.get("maxAmount")
                ? "Balance too high"
                : "Receive"
            }
            loadingText="Sending..."
            color="#07bc0c"
            cursor="pointer"
            disabled={
              Number(balance) >= config.get("maxAmount") || captcha === ""
            }
            hidden={Newaccount === "Not connected"}
            onClick={() =>
              faucetClaim(Newaccount, captcha)
                .then((hash) => {
                  toast.success("Transaction sent!");
                  setTxLink(hash);
                  setCaptcha("");
                  CheckBalance()
                })
                .catch((error) => {
                  console.log(error);
                  if (error.response && error.response.data) {
                    toast.error(`${error.response.data.err.message} 🙅`);
                  if(error.message === "Network Error"){
                    serverRestart()
                  }
                  if(error.response.data.err.message == "undefined" ){
                    console.log(error.response.data.err.data)
                    serverRestart()
                  }
                  } else {
                    toast.error(error.message);
                  }
                  setCaptcha("");
                })
            }
          />
         {Newaccount !=="Not connected" &&(
          <LoadButton
            text="Disconnect"
            loadingText="Loading..."
            color="#ccc"
            mycolor="#222"
            fontSize="12px"
            cursor="pointer"
            onClick={Disconnect}
          />
         )
         } 
        </div>
        <form id="receive" action="" method="POST">
          <HCaptcha
            theme="dark"
            sitekey={config.get("hcaptchasitekey")}
            onVerify={(token, ekey) => {
              setCaptcha(token);
            }}
          />
        </form>
        <p fontSize="14px" hidden={Newaccount === "Not connected"} >{Newaccount}</p>
        <p hidden={Newaccount === "Not connected"}>
          {"Your balance: " + String(balance)}
        </p>
        <a
          hidden={txLink === ""}
          target="_blank"
          rel="noopener noreferrer"
          href={txLink}
          // style={{color:"white"}}
        >
          {txLink}
        </a>
        <br></br>
      </div>
    </div>
  );
}

export default App;
